import React from 'react';

const Destination = () => {
    return (
        <div>
            <h1>This is Destination</h1>
        </div>
    );
};

export default Destination;